import { Design } from '../../../types';

/**
 * Ensure intent collection arrays exist on legacy AVS payloads that omit them.
 *
 * @note Fields are required on @see Design; normalization runs before consumers
 * such as export assume they are present.
 */
export function normalizeIntentCollections(serialized: Design) {
  serialized.compoundIntents ??= [];
  serialized.globalIntents ??= [];
}
